module.exports = __webpack_public_path__ + "static/media/11.281636f7.jpg";